<div class="legal" *ngIf='!isBusinessAdvisement'>
  <div class="modal-header">
    <div>
      <img src="/assets/tfb-acctmgmt/images/backicon.svg" class="mr-1 d-inline-block" alt="back icon">
      <a href="javascript:void(0)" class="changeService-title" (click)="closeButtonTagging($event)" aria-controls="slider" *ngIf ='!isFromRatePlan'>
        {{authoringContentData?.changeService?.changeServiceText}}
      </a>
      <a href="javascript:void(0)" class="changeService-title" (click)="closeButtonTagging($event)" aria-controls="slider" *ngIf ='isFromRatePlan'>
        {{authoringContentData?.changeService?.ChangeRatePlanTxt}}
      </a>
    </div>
    <button type="button" class="close" aria-label="Close" (click)="closeButtonTagging($event)">x</button>
  </div>
  <div class="let-modal">
    <div class="modal-header hdr-bt-0">
      <h4 class="modal-title">{{authoringContentData?.changeService?.serviceAggrementText}}</h4>
    </div>
  </div>

  <div class="modal-footer row m-t-40 justify-content-end">
    <button type="button" class="cancel-btn btn m-b-10" (click)="closeButtonTagging($event)">
      {{authoringContentData?.customizeAuthoring?.cancelCta}}
    </button>
    <button type="button" class="continueBtn btn m-b-10" (click)="closeButtonTagging($event)">
      {{authoringContentData?.changeService?.removeServiceContinueBtn}}
    </button>
  </div>

  <span class="servicespan" [innerHTML]="serviceTermsText"></span>
  <!-- Modal section -->
  <div class="BG-modal" [ngStyle]="{'display':display}"></div>
  <div class="modal terms-and-conditions-popup" tabindex="-1" role="dialog" [ngStyle]="{'display':display}">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header pb-2">
          <button type="button" class="close" aria-label="Close" (click)="test()">
            <span aria-hidden="true">&times;</span></button>
          

        </div>
        <div class="col-12 pb-2">
          <a href="javascript:void(0)" class="print" (click)="print()">
            <img src="/assets/tfb-acctmgmt/images/icons/icon_print_magenta.png" alt="" />test link
          </a>
        </div>
        <div class="modal-body ">
          <div class="modal-scroll  Lorem-ipsum-dolor-si" [innerHTML]="serviceTermsText" id="print"></div>
        </div>
        <div class="modal-footer">
          <button type="button" class="primary_btn marRgtTerms" (click)="test()">Close</button>
        </div>
      </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
  </div><!-- /.modal !-->
</div>




<div class="legal" *ngIf='isBusinessAdvisement'>
  <div class="modal-header">
    <div>
      <img src="/assets/tfb-acctmgmt/images/backicon.svg" class="mr-1 d-inline-block" alt="back button image">
      <a href="javascript:void(0)" class="changeService-title" (click)="OnClose()" aria-controls="slider">
        {{authoringContentData?.accountDetailsTab?.enrollPaperless}}
      </a>
    </div>
  </div>
  <div>
      <div class="let-modal">
        <div class="modal-header hdr-bt-0">
          <h4 class="modal-title">{{authoringContentData?.reviewChangeService?.serviceAgreementTxt}}</h4>
        </div>
      </div>
      <div class="col-12 pb-2 text-right">
        <a href="javascript:void(0)" class="print" (click)="print()">
          <img src="/assets/tfb-acctmgmt/images/icons/icon_print_magenta.svg" alt="" /><span class="print-color ml-2">Print</span>
        </a>
      </div>
  </div>

  <span class="servicespan" [innerHTML]="businessAdvisementText"></span>
  <!-- Modal section -->
  <div class="BG-modal" [ngStyle]="{'display':display}"></div>
  <div class="modal terms-and-conditions-popup" tabindex="-1" role="dialog" [ngStyle]="{'display':display}">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header pb-2">
          <button type="button" class="close" aria-label="Close" (click)="test()">
            <span aria-hidden="true">&times;</span></button>
          

        </div>
        <div class="col-12 pb-2">
          <a href="javascript:void(0)" class="print" (click)="print()">
            <img src="/assets/tfb-acctmgmt/images/icons/icon_print_magenta.svg" alt="" />test link
          </a>
        </div>
        <div class="modal-body ">
          <div class="modal-scroll  Lorem-ipsum-dolor-si" [innerHTML]="businessAdvisementText" id="print"></div>
        </div>
        <div class="modal-footer">
          <button type="button" class="primary_btn marRgtTerms" (click)="test()">Close</button>
        </div>
      </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
  </div><!-- /.modal !-->
</div>
